'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import { isAllowedPathname } from '@/utils/isAllowedPath';
import { notFound } from 'next/navigation';

// This catch-all page hands routing control over to the React Router <App />
const LegacyAppEntryDynamic = dynamic(() => import('@/components/LegacyAppEntry'), {
    ssr: false,
});

type Props = {
    params: { slug?: string[] };
};

export default function CatchAllPage({ params }: Props) {
    // 中文：把 slug 還原成 pathname（/a/b/c）
    // English: Rebuild pathname from slug segments
    const pathname = '/' + (params.slug?.join('/') ?? '');

    // 中文：不在 allow-list 內，直接回 404（HTTP status = 404）
    // English: If not allowed, return 404 HTTP status
    if (!isAllowedPathname(pathname)) {
        notFound();
    }
    // console.log(pathname);

    return <LegacyAppEntryDynamic />;
}
